import { render, staticRenderFns } from "./PaymentManagementPage.vue?vue&type=template&id=ef3a0cd4&scoped=true"
import script from "./PaymentManagementPage.vue?vue&type=script&lang=ts"
export * from "./PaymentManagementPage.vue?vue&type=script&lang=ts"
import style0 from "./PaymentManagementPage.vue?vue&type=style&index=0&id=ef3a0cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3a0cd4",
  null
  
)

export default component.exports